module.exports = __webpack_public_path__ + "img/singletrack-study-sector.f1fee70c.png";